"use client";

import { c as _c } from "react/compiler-runtime";
import { Button as ButtonPrimitive } from "@base-ui/react/button";
import { type VariantProps, cva } from "class-variance-authority";
import { cn } from "@v3/_/lib/utils";
const buttonVariants = cva("focus-visible:border-ring focus-visible:ring-ring/30 font-sans aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive dark:aria-invalid:border-destructive/50 rounded-sm border border-transparent bg-clip-padding text-xs/relaxed focus-visible:ring-[2px] aria-invalid:ring-[2px] [&_svg:not([class*='size-'])]:size-4 inline-flex items-center justify-center whitespace-nowrap transition-all disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none shrink-0 [&_svg]:shrink-0 outline-none group/button select-none", {
  variants: {
    variant: {
      default: "bg-primary text-primary-foreground font-medium hover:bg-primary/80",
      cover: "bg-cover-accent text-cover-accent-foreground font-medium hover:bg-cover-accent/85",
      outline: "border-border dark:bg-input/30 hover:bg-input/50 hover:text-foreground aria-expanded:bg-muted aria-expanded:text-foreground",
      "cover-outline": "border-border dark:bg-input/30 hover:bg-input/50 hover:text-foreground aria-expanded:bg-muted aria-expanded:text-foreground cover:border-cover-accent cover:text-cover-accent cover:hover:bg-cover-accent/10 cover:hover:text-cover-accent cover:aria-expanded:bg-cover-accent/10 cover:aria-expanded:text-cover-accent",
      secondary: "bg-secondary text-secondary-foreground hover:bg-secondary/80 aria-expanded:bg-secondary aria-expanded:text-secondary-foreground",
      ghost: "hover:bg-muted/50 hover:text-foreground dark:hover:bg-muted/20  aria-expanded:bg-muted aria-expanded:text-foreground",
      "real-ghost": "hover:bg-transparent hover:text-foreground aria-expanded:bg-transparent aria-expanded:text-foreground",
      destructive: "bg-destructive/10 hover:bg-destructive/20 focus-visible:ring-destructive/20 dark:focus-visible:ring-destructive/40 dark:bg-destructive/20 text-destructive focus-visible:border-destructive/40 dark:hover:bg-destructive/30",
      "ghost-destructive": "hover:bg-destructive/20 hover:text-destructive dark:hover:bg-destructive/30 text-destructive focus-visible:ring-destructive/20 dark:focus-visible:ring-destructive/40",
      link: "text-primary underline-offset-4 hover:underline"
    },
    size: {
      default: "h-8 gap-1.5 px-3 text-xs has-data-[icon=inline-end]:pr-2 has-data-[icon=inline-start]:pl-2 [&_svg:not([class*='size-'])]:size-3.5",
      xs: "h-6 gap-1 rounded-sm px-2 text-[0.625rem] has-data-[icon=inline-end]:pr-1.5 has-data-[icon=inline-start]:pl-1.5 [&_svg:not([class*='size-'])]:size-2.5",
      sm: "h-7 gap-1 px-2.5 text-xs has-data-[icon=inline-end]:pr-2 has-data-[icon=inline-start]:pl-2 [&_svg:not([class*='size-'])]:size-3",
      lg: "h-9 gap-1.5 px-3.5 text-xs has-data-[icon=inline-end]:pr-2.5 has-data-[icon=inline-start]:pl-2.5 [&_svg:not([class*='size-'])]:size-4",
      icon: "size-8 [&_svg:not([class*='size-'])]:size-3.5",
      "icon-xs": "size-6 rounded-sm [&_svg:not([class*='size-'])]:size-2.5",
      "icon-sm": "size-7 [&_svg:not([class*='size-'])]:size-3",
      "icon-lg": "size-9 [&_svg:not([class*='size-'])]:size-4"
    }
  },
  defaultVariants: {
    variant: "default",
    size: "default"
  }
});
function Button(t0) {
  const $ = _c(12);
  let className;
  let props;
  let t1;
  let t2;
  if ($[0] !== t0) {
    ({
      className,
      variant: t1,
      size: t2,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = props;
    $[3] = t1;
    $[4] = t2;
  } else {
    className = $[1];
    props = $[2];
    t1 = $[3];
    t2 = $[4];
  }
  const variant = t1 === undefined ? "default" : t1;
  const size = t2 === undefined ? "default" : t2;
  let t3;
  if ($[5] !== className || $[6] !== size || $[7] !== variant) {
    t3 = cn(buttonVariants({
      variant,
      size,
      className
    }));
    $[5] = className;
    $[6] = size;
    $[7] = variant;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] !== props || $[10] !== t3) {
    t4 = <ButtonPrimitive data-slot="button" className={t3} {...props} />;
    $[9] = props;
    $[10] = t3;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  return t4;
}
export { Button, buttonVariants };